export const modals = {
  sure: "Подтвердите действие",
};
